import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SignUpPageService {

    private API_URL= environment.API_URL;

    constructor(
        private http : HttpClient
    ) {}

    getData(){
        let url = `${this.API_URL}/sign-up?populate=*`;
        return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
    }

    registerUser(user: { name: string; email: string; password: string }) {
        const uniqueUsername = `${user.name.toLowerCase().replace(/\s+/g, '-')}-${Date.now()}`;
      
        const payload = {
          username: uniqueUsername, // requis par Strapi
          email: user.email,
          password: user.password,
          name: user.name // champ personnalisé dans Strapi
        };
      
        const url = `${this.API_URL}/auth/local/register`;
        return this.http.post<any>(url, payload, {
          headers: { 'Authorization': `Bearer ${environment.API_TOKEN}` }
        });
      }      

}